// 配置 MathJax
export const MathJaxConfig = {
  chtml: {
    fontURL: '/mathjax/output/chtml/fonts/woff-v2', // public 下字体目录
    scale: 1
  },
  loader: { load: ['input/mml', 'input/tex', 'output/chtml'] },
  tex: {
    inlineMath: [['$', '$'], ['\\(', '\\)']],
    displayMath: [['$$', '$$'], ['\\[', '\\]']]
  },
  startup: { typeset: false } // 延迟 typeset
};

// 初始化 MathJax
export function initMathJax() {
  if (typeof window !== 'undefined' && !window.MathJax) {
    window.MathJax = MathJaxConfig;
    // 动态加载官方 es5/mml-chtml.js
    const script = document.createElement('script');
    script.src = '/mathjax/es5/tex-mml-chtml.js'; // Use bundle with TeX support
    script.async = true;
    document.head.appendChild(script);
  }
}

// 渲染指定容器
export async function renderMathML(el) {
  if (!el) return;
  // 等待 MathJax 加载
  if (el.querySelector("mjx-container")) return; // 已经渲染过
  if (!window.MathJax || (!window.MathJax.typesetPromise && !window.MathJax.typeset && !window.MathJax.Hub)) {
    await new Promise((resolve) => {
      let timeout = setTimeout(resolve, 3000); // 3 seconds fallback
      const interval = setInterval(() => {
        if (window.MathJax && (window.MathJax.typesetPromise || window.MathJax.typeset || window.MathJax.Hub)) {
          clearInterval(interval);
          clearTimeout(timeout);
          resolve();
        }
      }, 50);
    });
  }

  try {
    if (window.MathJax && window.MathJax.typesetPromise) {
      await window.MathJax.typesetPromise([el]);
    } else if (window.MathJax && window.MathJax.typeset) {
      window.MathJax.typeset([el]);
    } else if (window.MathJax && window.MathJax.Hub && window.MathJax.Hub.Queue) {
      window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub, el]);
    } else {
      console.warn('MathJax not ready or not found.');
    }
  } catch (err) {
    console.error('MathJax 渲染错误:', err);
  }
}